import '../../../pages/Tabs.scss';

import Box from '@mui/material/Box/Box';
import { Tab, Tabs } from '@trackman/web-shared-components';
import { AnalyticsTabsRelativeRoutes } from 'Routes';
import { Outlet, useNavigate } from 'react-router-dom';
import useSetPageTitle from 'utilities/useSetPageTitle';
import { useTabsStore } from 'stores/TabsStore';

export const Analytics = () => {
  const navigate = useNavigate();
  const { activeTabIndex } = useTabsStore();

  useSetPageTitle({ title: 'Analytics' });

  return (
    <>
      <div className='default-page-header'>
        <h1 className='page-title'>Analytics</h1>
      </div>
      <Box className='tabs-container'>
        <Tabs scrollButtons='auto' value={activeTabIndex} variant='scrollable' indicatorColor='primary' allowScrollButtonsMobile>
          <Tab label='Overview' onClick={() => navigate(AnalyticsTabsRelativeRoutes.Overview)} />
          <Tab label='Organizations' onClick={() => navigate(AnalyticsTabsRelativeRoutes.Organizations)} />
          <Tab label='Webinars' onClick={() => navigate(AnalyticsTabsRelativeRoutes.Webinars)} />
          <Tab label='Certificates' onClick={() => navigate(AnalyticsTabsRelativeRoutes.Certificates)} />
          <Tab label='Financial' onClick={() => navigate(AnalyticsTabsRelativeRoutes.Financial)} />
        </Tabs>
      </Box>
      <Outlet />
    </>
  );
};

export default Analytics;
